const ApiUrl = {
  // Categories API Url
  ReadView: '/product/v1/masterview/read',
  ReadFamilyFeature: '/ace/productmodel/v1/families/read',
  ReadCategories: '/category/v1/read',
  SaveView: '/product/v1/masterview/save',
  ReadMultiNumericFeature: '/feature/v1/read',

  //PDM API url
  ReadProperties: '/property/v1/read',
  ReadPropertyAssociation: '/property/v1/association/read',
  CreatePropertyAssociation: '/property/v1/association/create',
  ReadLov: '/lov/v1/details',
  ReadProductHierarchy: '/product/v1/hierarchy/read',
  SendNotification: '/producer/v1/notification',

  //Procos API url
  ReadWIs: '/ace/v1/wi/read',
  ReadMarkets: '/lib/v1/market/read',
  ReadMarketAssociation: '/ace/productmodel/v1/rules/markets/read',
  CreateRules: '/ace/productmodel/v1/rules/ma/create',
  CreateWorkItem: '/ace/v1/wi/create',
  CreateEffectivity: '/ace/productmodel/v1/effectivity/save',
  ProcosExport: '/export/v1/product/procos/excel',
  PcsExport: '/export/v1/product/pcs/excel',

  //Product API url
  ReadProductModels: '/ace/v1/productmodel/read',

  //User API url
  ReadUserDetails: '/user/v1/details',

  //MultinNumericFeature API url
  CreateMultiNumericFeature: '/feature/v1/create',
  UpdateMultiNumericFeature: '/feature/v1/update',
  DeleteMultinumericFeature: '/feature/v1/delete',

  //Pdm History API url
  PdmFeatureHistory: '/history/v1/propertiesassociation/read',
} as const;

export default ApiUrl;
